import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BasePageListComponent } from 'src/app/shared/components/base/base.pagelist.component';
import { StockRoomListDto, StockRoomQuery } from '../models/stock-room';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { VisGridComponent } from 'src/app/shared/components/grid/vis-grid/vis-grid.component';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { UserCache } from 'src/app/services/user-cache';
import { ProductApi } from 'src/app/services/api-service/stocks/product-api';
import { BaseConfig } from 'src/app/services/base-config.service';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { StockQuery } from '../../product/models/product';

@Component({
  selector: 'app-stock-room-list',
  templateUrl: './stock-room-list.component.html',
  styleUrls: ['../../shared/stock-common.css', './stock-room-list.component.css']
})
export class StockRoomListComponent extends BasePageListComponent<StockRoomListDto> implements OnInit {

  @ViewChild('grid') grid: VisGridComponent;
  editComponent: any = null;

  private _productId = 0;
  @Input() set productId (value: number) {
    this._productId = value;
    if (value == 0) {
        return;
    }
    if (this.queryFormGroup) {
      this.refreshList();
    }
  }
  get productId(): number {
    return this._productId;
  }
  @Input() isExpand: boolean = false;
  @Input() showLowStockOnly: boolean = false;
  @Input() topHint: string = '';

  stockQuery: StockQuery = null;
  @Input() set externalStockQuery(value: StockQuery) {
    this.stockQuery = value;
  }

  @Output() onEmitExpandOrShrink = new EventEmitter<boolean>();
  @Output() onEmitStockQueryChange = new EventEmitter<StockQuery>();

  isStockHeadquarters = UserCache.IsStockHeadquarters();
  clinicCode = this.isStockHeadquarters ? '' : (UserCache.getLoginUser().Clinic?.Code || '');
  clinics: ValueTextPair[] = [];
  pageSize = BaseConfig.getConfig().ui.pageSize;
  today = DateHelper.today;
  todayRoc = DateHelper.getROCDateStringWithSepetator(this.today);
  labelMsg = '';

  constructor(
    private fb: FormBuilder,
    private webApiClient: WebApiClient,
    private notificationDI: EasyNotificationService,
    private clinicData: ClinicDataService,
    private productApi: ProductApi
  ) {
    super();
    this.api = this.webApiClient.createHisService('Stocks/StockRoom');
    this.notification = notificationDI;
  }

  async ngOnInit() {
    this.createQueryFormGroup();
    const clinicList = await this.clinicData.GetClinicList();
    this.clinics = clinicList.map(c => ({ value: c.Code, text: c.Name, extension: c.Id }));
    this.clinics = this.productApi.AddEmptyOption(this.clinics);

    if (this.stockQuery && this.queryFormGroup) {
      this.queryFormGroup.patchValue({
        clinicCode: this.stockQuery.clinicCode
      }, { emitEvent: false });
    }

    if (this.showLowStockOnly) {
      this.refreshList();
    } else if (this.productId && this.queryFormGroup) {
      this.refreshList();
    }
  }

  handleListData(data: StockRoomListDto[]) {
    const list = data ?? [];
    if (this.showLowStockOnly) {
      this.labelMsg = list.length === 0 ? '庫存正常' : '庫存不足';
    } else {
      this.labelMsg = '';
    }
    return list;
  }  

  makeQueryFormGroup() {
    return this.fb.group({
      clinicCode: [{ value: this.clinicCode, disabled: !this.isStockHeadquarters }],
      productCode: [''],
      productName: ['']
    });
  }

  makeQueryConditions(): StockRoomQuery {
    const raw = this.queryFormGroup.getRawValue();
    const clinicCode = raw.clinicCode || null;
    const clinicId = clinicCode ? this.clinics.find(c => c.value === clinicCode)?.extension : null;
    const productCode = raw.productCode?.trim() || '';
    const productName = raw.productName?.trim() || '';
    
    return {
      clinicId: clinicId,
      clinicIds: clinicId ? '' : this.clinics.filter(c => c.extension).map(c => c.extension).join(','),
      productId: this.productId,
      productCode: productCode,
      productName: productName,
      lowStockOnly: this.showLowStockOnly
    };
  }

  onBtnQueryClick() {
    super.onBtnQueryClick();
    if (this.stockQuery) {
      this.stockQuery.clinicCode = this.queryFormGroup.controls['clinicCode'].value;
      this.onEmitStockQueryChange.emit(this.stockQuery);
    }
  }

  expandOrShrink(isExpand: boolean) {
    this.isExpand = isExpand;
    this.onEmitExpandOrShrink.emit(this.isExpand);
  }
}
